import { endpoints, poster, fetcherGET, fetcherSwr, patcher } from '../utils/axios';
import useSWR from 'swr';

export const closeNotification = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.notifications.closeNotification}`, args);
    return response;
  } catch (error) {
    console.error("closeNotification error:", error);
    return {
      success: false,
      message: error?.response?.data?.message ?? error.message,
    };
  }
};

//  Notifications hook with SWR
export const useNotifications = (params = {}) => {

const URL = [endpoints.notifications.getNotifications, { params: params }];

  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);
  return {
    notifications: data?.data ?? [],   // API returns { success, message, data: [...] }
    message: data?.message ?? "",
    isLoading,
    isError: !!error,
    error
  };
};

export const acceptNotification = async (args = {}) => {
  try {
    const response = await patcher(`${endpoints.cases.acceptReferral}`, args);
    return response;
  } catch (error) {
    console.error("acceptNotification error:", error);
    return {
      success: false,
      message: error?.response?.data?.message ?? error.message,
    };
  }
};
export const rejectNotification = async (args = {}) => {
  try {
    const response = await patcher(`${endpoints.cases.rejectReferral}`, args);
    return response;
  } catch (error) {
    console.error("rejectNotification error:", error);
    return {
      success: false,
      message: error?.response?.data?.message ?? error.message,
    };
  }
};
